﻿import axios from 'axios';
import { locateStore } from'./gtmdata_wp';
import { scrollToTarget } from'../../utils';

let map;
let fs;
let filteredJsonInventory = [];
const inventoryShowAll = document.getElementById('inventoryShowAll');
const postalCodeInput = document.getElementById('inventoryPostnumber');

const ajax = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    },
});

const favourite = id => {
    if (fs == id) {
        return ' is-favourite';
    } else {
        return '';
    }
};

const clearStore = (store) => {
    store.removeAttribute('checked');
    store.classList.remove('is-active');
};

const resetFields = () => {
    inventoryShowAll.classList.remove('is-hidden');
    const inventoryPostnumber = document.getElementById('inventoryPostnumber');
    if (inventoryPostnumber) {
        inventoryPostnumber.classList.remove('invalid');
    }
    const inventoryNoHits = document.getElementById('inventoryNohits');
    if (inventoryNoHits) {
        inventoryNoHits.classList.add('is-hidden');
    }
};

const updatePosition = () => {
    // User enters po-number
    const searchInput = document.getElementById('inventoryPostnumber').value;
    useMyLocationButton.forEach(el => {
        el.classList.remove('disabled');
    });

    // Define if search i text or PO number
    function searchQuery() {
        if (searchInput > 0 && searchInput < 9999) {
            return '?postalCode=' + searchInput;
        } else {
            return '?postalPlace=' + searchInput;
        }
    }

    // Generate url
    const postNordApiUrl = '/publicapi/findstore';
    const postNordQuery = searchQuery(searchInput);
    const postNordUrl = postNordApiUrl + postNordQuery;
    const inventoryPostnumber = document.getElementById('inventoryPostnumber');

    ajax.get(postNordUrl)
        .then(response => {
            if (response.status === 204) {
                // Handle 204 No Content response same way as 404 Not Found
                if (inventoryPostnumber) {
                    inventoryPostnumber.classList.add('invalid');
                }
                filteredJsonInventory = [];
                updateMapList(59.9142366, 10.75309029999994, 1000);
            } else {
                if (inventoryPostnumber) {
                filteredJsonInventory = response.data;
                const lat = parseFloat(response.data[0].latitude);
                const long = parseFloat(response.data[0].longitude);
                mapInventory(
                    lat,
                    long,
                    false,
                    1000,
                    response.data,
                    window.jsonInventory,
                );
                updateMapList(
                    lat,
                    long,
                    1000);
            }
            resetFields();
        }})
        .catch(e => {
            if (e && e.response && e.response.status === 404) {
                if (inventoryPostnumber) {
                    inventoryPostnumber.classList.add('invalid');
                }
                filteredJsonInventory = [];
                updateMapList(59.9142366, 10.75309029999994, 1000);
            }
        });
};

// If less than 1km use meters
const distanceRounder = (located, dist) => {
    if (located && dist >= 1) {
        return parseFloat(dist).toFixed(2) + 'km';
    } else if (located && dist < 1) {
        return parseFloat(dist * 1000).toFixed(0) + 'm';
    } else {
        return '';
    }
};

// HTML list
// Make class is-hidden in list if too far from user
const toofar = (radius, located, where) => {
    if (where > radius && located) {
        return 'is-hidden';
    } else {
        return 'is-visible';
    }
};

const decodeEntities = encodedString => {
    const parser = new DOMParser;
    const dom = parser.parseFromString(
        '<!doctype html><body>' + encodedString,
        'text/html');
    return dom.body.textContent;
};

const mapInventory = (userLat, userLng, located, accuracy, stores, jsonInventory, sortOnDistance = false) => {
    const storeItems = document.querySelectorAll('._js-inventory-store');
    if (window.google) {
        // Initial map setup
        let isInitial = true;
        if (storeItems.length > 0) {
            storeItems.forEach(el => {
                el.classList.add('is-hidden');
            });
            isInitial = false;
        }

        if (!isInitial) {
            document.querySelectorAll('._js-inventory-store').forEach(el => {
                el.remove();
            });
        }

        useMyLocationButton.forEach(el => {
            el.classList.remove('disabled');
        });

        const myLatLng = {lat: userLat, lng: userLng};
        const markers = [];
        const storeCounter = [];

        const radius = 20;

        // Make bounds to zoom map to correct position
        const bounds = new window.google.maps.LatLngBounds();
        const boundsAll = new window.google.maps.LatLngBounds();

        // Make infowindow displayed on markers
        let infowindow = new window.google.maps.InfoWindow();

        // Giving the map som options
        const mapOptions = {
            center: myLatLng,
            fullscreenControl: false,
            mapTypeControl: false,
            zoom: 2,
            maxZoom: 18,
            styles: [
                {
                    'featureType': 'poi.business',
                    'stylers': [
                        {
                            'visibility': 'off'
                        }
                    ]
                }
            ]
        };

        if (map) {
            map = null;
        }
        // Creating the map
        const mapDiv = document.getElementById('mapInventory');
        if (mapDiv) {
            map = new window.google.maps.Map(document.getElementById('mapInventory'), mapOptions);
        }

        function currentStore(el) {
            const selectedStore = document.getElementById(el);
            if (selectedStore) {
                document.querySelectorAll('._js-inventory-store').forEach(store => {
                    clearStore(store);
                });

                selectedStore.querySelector('input').setAttribute('checked', true);
                selectedStore.classList.add('is-active');
            }
        }

        // Click events
        // Adding a new click event listener for the object
        // In map
        function addClicker(marker, content, id) {
            window.google.maps.event.addListener(marker,
                'click',
                function () {
                    currentStore(id);
                    const mq = window.matchMedia('(min-width: 64em)');
                    if (mq.matches) {
                        if (infowindow) {
                            infowindow.close();
                        }
                        infowindow = new window.google.maps.InfoWindow({content: content});
                        infowindow.open(map, marker);
                    }
                    map.setZoom(14);
                    map.panTo(marker.position);
                    document.getElementById('storeInventory').classList.add('has-store-selected');
                }
            );
        }

        let usersPositionMarker = null;
        function setUserPosition(lat, lng) {
            const currentLat = lat;
            const currentLng = lng;

            // Marker style
            const userPin = {
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: '#507cec',
                fillOpacity: 1,
                scale: 7,
                strokeColor: 'white',
                strokeWeight: 2,
                anchor: new window.google.maps.Point(0, 0)
            };
            usersPositionMarker = new window.google.maps.Marker({
                map: map,
                position: new window.google.maps.LatLng(currentLat, currentLng),
                title: 'Deg',
                icon: userPin,
                zIndex: 1000,
                id:'usersPositionMarker'
            });
            markers.push(usersPositionMarker);
            const clicker = addClicker(usersPositionMarker,'Her er du');
        }

        //Set user postion
        if (located && accuracy < 300) {
            setUserPosition(userLat, userLng);
        }
        if (stores && stores.length > 0) {
            let objs = [].concat(stores).map((store) => {
                return { distance: getDistanceFromLatLonInKm(store.latitude, store.longitude, userLat, userLng),  obj: store,
                };
            });
            
            if(sortOnDistance) {
                objs = objs.sort((a, b) => {
                    return a.distance < b.distance ? -1 : 1;
                });
            }
            
            objs.forEach(({ distance, obj }) => {
                const sizesArr = ((jsonInventory || []).find(x => x.id === obj.id) || obj).sizes || [];
                const sizes = Array.isArray(sizesArr) ? sizesArr.map(s => s.name).join(", ") : sizesArr;

                const distanceRound = distanceRounder(located, distance);

                const fav = favourite(obj.id);
                const far = toofar(radius, located, distance);

                const HTMLid = String(obj.id);
                const HTMLtitle = '<h3 class="store-inventory__title">' + obj.title + '</h3>';
                const HTMLfav = '<button role="button" hidden class="store-inventory__fav-btn _js-fs-button' +
                    fav +
                    '" value="' +
                    obj.id +
                    '"><span class="store-inventory__set-as-favorite">Sett som </span>favoritt</button>';
                const HTMLsizes = sizes ?
                    '<ul class="store-instock"><li class="store-instock__item">' + sizes +'</li></ul>' :
                    '';
                const HTMLadress = '<div class="store-inventory__adress">' +
                    HTMLfav +
                    '<span>' + obj.adress + '</span>' +
                    '<span>' + obj.openinghours + '</span>';
                let HTMLphone = '';
                if (obj.tel && obj.tel.length > 0) {
                    HTMLphone = '<a href="tel:' +
                        obj.tel.replace(/\s/g, '') +
                        '" class="store-inventory__link" tabindex="0">Ring: ' +
                        obj.tel +
                        ' </a> ';
                }
                const HTMLnav = '<a href="https://www.google.com/maps/search/?api=1&query=' +
                    encodeURIComponent(obj.adress) +
                    '+' +
                    encodeURIComponent(obj.title) +
                    '" class="store-inventory__link" target="_blank">Finn veien</a>';

                const decodedTitle = decodeEntities(obj.title);

                // Content
                const contentString = '<div class="store-inventory__list__item--align">' +
                    '<span class="store-inventory__distance">' +
                    distanceRound +
                    '</span>' +
                    HTMLtitle +
                    HTMLadress +
                    '<div class="store-inventory__actions">' +
                    HTMLsizes +
                    '<div class="store-inventory__links">' +
                    HTMLphone +
                    HTMLnav +
                    '</div>' +
                    '</div>' +
                    '<input type="radio" name="storeInventoryStore" class="sr-only" value="' +
                    obj.id +
                    '" aria-label="Velg i kart" />' +
                    '</div>';

                // Marker style
                const pin = {
                    path:
                        'M14,2.6c-4.3,0-7.9,3.5-7.9,7.9c0,1.2,0.5,2.6,1.2,4.2c0.7,1.5,1.5,3.2,2.4,4.7c1.8,3.1,3.6,5.6,3.6,5.6l0.7,1l0.7-1c0,0,1.8-2.6,3.6-5.6c0.9-1.5,1.8-3.2,2.4-4.7c0.7-1.5,1.2-3,1.2-4.2C21.9,6.2,18.3,2.6,14,2.6z M14,14.3c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8C17.8,12.6,16.1,14.3,14,14.3z',
                    fillColor: 'red',
                    fillOpacity: 1,
                    scale: 1.5,
                    strokeColor: 'white',
                    strokeWeight: 1,
                    anchor: new window.google.maps.Point(15, 30)
                };

                // Marker style Favourite store
                const pinFav = {
                    path:
                        'M19.3,11.7L9.9,22.1c-0.2,0.2-0.5,0.2-0.7,0l0,0l-9.4-10.4C-3,8.6-3,3.8-0.2,0.7c2.4-2.8,6.7-3.1,9.5-0.6c0.1,0.1,0.2,0.2,0.3,0.3c1.3-1.2,2.9-1.9,4.7-1.9c1.9,0,3.8,0.8,5.1,2.3C22,3.9,22,8.6,19.3,11.7z',
                    fillColor: 'red',
                    fillOpacity: 1,
                    scale: 1,
                    strokeColor: 'white',
                    strokeWeight: 2,
                    anchor: new window.google.maps.Point(15, 30)
                };

                // Decide if favourite store
                if (fs == obj.id) {
                    // Adding a new marker for the object
                    var marker = new window.google.maps.Marker({
                        position: new window.google.maps.LatLng(obj.latitude, obj.longitude),
                        icon: pinFav,
                        map: map,
                        infowindow: infowindow, // this works, giving the marker a title with the correct title,
                        title: decodedTitle,
                        id: HTMLid
                    });

                    // Push marker to markers list
                    markers.push(marker);
                } else {
                    // Adding a new marker for the object
                    var marker = new window.google.maps.Marker({
                        position: new window.google.maps.LatLng(obj.latitude, obj.longitude),
                        icon: pin,
                        map: map,
                        infowindow: infowindow, // this works, giving the marker a title with the correct title,
                        title: decodedTitle,
                        id: HTMLid
                    });

                    // Push marker to markers list
                    markers.push(marker);
                }

                // Adding a new info window for the object
                const clicker = addClicker(marker, contentString, HTMLid);

                // Add elements within 20km if located user to bounds
                if (distance < radius && located) {
                    //Extend bound using items-position
                    bounds.extend(new window.google.maps.LatLng(obj.latitude, obj.longitude));
                    storeCounter.push(obj.id);
                } else if (distance < 3000 && !located) {
                    boundsAll.extend(new window.google.maps.LatLng(obj.latitude, obj.longitude));
                } else if (located) {
                    boundsAll.extend(new window.google.maps.LatLng(obj.latitude, obj.longitude));
                }

                // Add to html-list
                const HTMLlistItem = '<li class="store-inventory__list__item _js-inventory-store ' +
                    far +
                    fav +
                    '" id="' +
                    HTMLid +
                    '" data-distance="' +
                    distance +
                    '">' +
                    contentString +
                    '</li>';

                const list = document.querySelector('._js-inventory-list');

                if (list) {
                    list.insertAdjacentHTML('beforeend', HTMLlistItem);
                }
            });
        }

        if (map) {
            if (storeCounter.length > 0) {
                map.fitBounds(bounds);
            } else {
                map.fitBounds(boundsAll);
            }
        }

        document.querySelectorAll('._js-inventory-store').forEach(el => {
            el.addEventListener('click', e => {
                if (window.matchMedia('(max-width: 64em)').matches) {
                    scrollToTarget('#mapInventory');
                }

                if (el && el.id) {
                    const marker = markers.find(m => m.id === el.id);
                    if (marker && map) {
                        window.google.maps.event.trigger(marker, 'click');
                        map.setZoom(14);
                        map.panTo(marker.position);
                        locateStore(marker.title);
                    }
                }
            });
        });

        document.querySelectorAll('._js-fs-button').forEach(b => {
            b.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                const targetElement = e.currentTarget;
                const favId = targetElement.value;

                document.querySelectorAll('.is-favourite').forEach(fav => {
                    fav.classList.remove('is-favourite');
                });
                targetElement.classList.add('is-favourite');
                
                const favoriteElement = document.getElementById(favId);
                if (favoriteElement) {
                    favoriteElement.classList.add('is-favourite');
                }
                
                setFavoriteStore(favId);
                
                const sidebar = document.querySelector('.store-inventory__sidebar');
                if (sidebar) {
                    sidebar.scrollTop = 0;
                }
            });
        });
    }
};

// Changing postnumber (click on button or enter in input)
const postalCodeInputButton = document.getElementById('inventoryPostnumberButton');
if (postalCodeInputButton) {
    postalCodeInputButton.addEventListener('click', updatePosition);
}

if (postalCodeInput) {
    postalCodeInput.addEventListener('keypress', e => {
        if (e.keyCode == 13) {
            updatePosition();
        }
    });
}

// Show all button
if (inventoryShowAll) {
    const inventoryShowAllEvent = () => {
        updateMapList(59.9142366, 10.75309029999994, 1000);
        initialMap();
        inventoryShowAll.classList.add('is-hidden');
        postalCodeInput.value ='';
    };
    inventoryShowAll.addEventListener('click', inventoryShowAllEvent);
}

const initialMap = () => {
    resetFields();
    mapInventory(59.9142366, 10.75309029999994, false, 10000, window.jsonInventory);
    inventoryShowAll.classList.add('is-hidden');
};

const getFavoriteStore = () => ajax.get('/publicapi/findstore/getFavoriteStore/');
const setFavoriteStore = storeId => {
    ajax.post(
        '/publicapi/findstore/setFavoriteStore/',
        JSON.stringify(storeId),
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    );
};

// Updating the bounds of the map
const updateMapList = (updatedLat, updatedLng, updateRadius) => {
    document.querySelectorAll('._js-inventory-store').forEach(el => {
        clearStore(el);
        el.classList.add('is-hidden');
    });

    // Define new bounds
    const bounds = new window.google.maps.LatLngBounds();

    // Add user lnglat to bounds
    bounds.extend(new window.google.maps.LatLng(updatedLat, updatedLng));

    const storeCount = [];

    for (let i = 0; i < filteredJsonInventory.length; i++) {
        const obj = filteredJsonInventory[i];

        //Find distance in km
        const distance = getDistanceFromLatLonInKm(obj.latitude, obj.longitude, updatedLat, updatedLng);
        const storeElement = document.getElementById(obj.id);

        if (distance < updateRadius) {
            //Extend bound using items-position
            bounds.extend(new window.google.maps.LatLng(obj.latitude, obj.longitude));
            if (storeElement) {
                storeElement.classList.remove('is-hidden');
            }
            storeCount.push(obj.id); // Count number of stores within radius
        } else {
            if (storeElement) {
                storeElement.classList.remove('is-visible');
                storeElement.classList.add('is-hidden');
            }
        }
    }

    // Only fit bounds if any store hits
    if (storeCount.length > 0) {
        if (map) {
            // update bounds
            map.fitBounds(bounds);
        }
        document.getElementById('inventoryNohits').classList.add('is-hidden');
        document.getElementById('inventoryShowAll').classList.add('is-hidden');
    } else {
        document.getElementById('inventoryNohits').classList.remove('is-hidden');
        document.getElementById('inventoryShowAll').classList.remove('is-hidden');
    }
};

// Tools
// **************************

const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
};
const useMyLocationButton = document.querySelectorAll('._js-use-my-location');


const deg2rad = deg => deg * (Math.PI / 180);

export const initMap = () => {
    getFavoriteStore()
        .then(response => {
            fs ='';
            if (response && response.data !== '') {
                fs = response.data;
            }
            initialMap();
        })
        .catch(error => {
            initialMap();
            //console.log(error)
        });

    function onGeolocateSuccess(pos) {
        if (navigator.geolocation) {
            const crd = pos.coords;
            mapInventory(crd.latitude,
                crd.longitude,
                true,
                crd.accuracy,
                window.jsonInventory,
                null,
                true,
            ); // True used to indicate if we actually have a user position
            resetFields();
        }
    }

    function onGeolocateError() {
        useMyLocationButton.forEach(el => {
            el.classList.add('disabled');
        });
    }

    useMyLocationButton.forEach(el => {
        el.addEventListener('click', e => {
            navigator.geolocation.getCurrentPosition(onGeolocateSuccess, onGeolocateError, { timeout: 5000 });
        });
    });
};


export const init = () => {
    initMap();

    /* Trigger "show all" button if list remains empty after 2 seconds to avoid grey map */
    setTimeout(function () {
        if (document.querySelectorAll('._js-inventory-store').length == 0) {
            inventoryShowAll.click();
        }
    }, 2000);
};
